export const bankDeposit = {
  depositInstructions: "存款说明",
  depositInstructionsMessageVzla: "注册您的手机支付以自动进行 BDV 支付。如果您已经在未注册的情况下支付，请使用此表格。",
  depositInstructionsMessagePlaza:
    "尊敬的用户，为了验证您的手机支付并将其存入您的虚拟钱包，您必须使用与注册用户时相同的身份证和电话号码进行支付。如果您有与同一身份证关联的其他电话号码，只需将其添加到您的手机支付账户中，即可存入款项。",
  depositInstructionsImportantMessage: "重要：存款将在您点击继续时更新",
  depositInstructionsBank: "银行",
  depositInstructionsMobilePhone: "手机号码",
  depositInstructionsContinue: "继续",
  depositInstructionsBack: "返回",
  depositInstructionsCancel: "取消",
  depositInstructionsCopy: "复制",
  depositInstructionsCopied: "已复制",
  depositInstructionsError: "发生错误:",
  depositInstructionsOptions: "为了继续，请从可用存款方法中选择一个",
  depositInstructionsBankTitle: "成功!",
  depositInstructionsBankSuccess: "存款合并成功!",
  depositInstructionsBankWarning: "注意!",
  depositInstructionsBankError: "未找到交易",

  depositInstructionsBankOptionsTitle: "为了继续，请选择一个银行",
  depositInstructionsBankOptions: "选择一个银行",
  depositInstructionsBankVzlaSelectDate: "选择日期",

  depositInstructionsCancelBtn: "取消",
  depositInstructionsCopyBtnTitle: "按下按钮复制",

  // VENEZUELA BANK
  depositInstructionsBankVzlaReference: "参考",
  depositInstructionsBankVzlaAmount: "金额",
  depositInstructionsBankVzlaDate: "日期",
  depositInstructionsBankVzlaBank: "银行",
  depositInstructionsBankVzlaBankOptions: "选择一个银行",
  depositInstructionsBankVzlaForm: "表单",
  depositInstructionsBankVzlaFormTitle: "支付注册表",
  depositInstructionsBankVzlaFormInfo: "如果您已经付款，请使用此表单。",

  // ZELLE
  depositInstructionsZelleMessage: "在进行此 Zelle 交易之前，您必须联系支持人员以验证 USD 转换为玻利瓦尔并验证您的付款",
  depositInstructionsZelleEmail: "电子邮件",
  depositInstructionsZelleCopyBtnTitle: "点击按钮复制电子邮件",
  depositInstructionsSupport: "联系支持",

  //BINANCE
  depositInstructionsBinanceTitle: "Binance USDT 存款",
  depositInstructionsBinanceAmount: "金额",
  depositInstructionsBinanceMinAmount: "最低存款",
  depositInstructionsBinanceCompletePayment: "完成您的 Binance 付款",
  depositInstructionsBinanceOptions: "选择您喜欢的付款方式",
  depositInstructionsBinanceOptionsTitle: "付款方式",
  depositInstructionsBinanceUseQR: "使用您的 Binance 应用扫描此 QR 代码",
  depositInstructionsBinanceLink: "点击以打开 Binance 的付款页面",
  depositInstructionsBinanceOpenLink: "打开 Binance 付款链接",
  depositInstructionsBinanceStatus: "交易状态",
  depositInstructionsBinanceContinue: "继续",
  depositInstructionsBinanceBack: "返回",
  depositInstructionsBinanceCheckingStatus: "检查状态...",
  depositInstructionsBinancePending: "待处理",
  depositInstructionsBinanceEnterAmount: "输入要存入的金额",
  depositInstructionsBinanceGeneratedLink: "支付链接已生成！选择您喜欢的支付方式。",
  depositInstructionsBinanceError: "创建存款失败。请再试一次。",
  depositInstructionsBinanceValidAmount: "请输入有效金额",
  depositInstructionsBinancePaymentCompleted: "付款成功完成！",
  depositInstructionsBinanceScanQR: "扫描二维码",
  depositInstructionsBinancePaymentLinkTitle: "付款链接",
  depositInstructionsBinanceOrSeparator: "或",

  //PAYKU
  depositInstructionsPaykuTitle: "Payku CLP 存款",
  depositInstructionsPaykuDescription: "使用各种付款方式以智利比索进行存款",
  depositInstructionsPaykuAmount: "金额",
  depositInstructionsPaykuEmail: "电子邮件",
  depositInstructionsPaykuPaymentMethod: "付款方式",
  depositInstructionsPaykuMinAmount: "最低存款：1,000 CLP",
  depositInstructionsPaykuEnterAmount: "输入要存入的金额",
  depositInstructionsPaykuEmailPlaceholder: "你的@邮箱.com",
  depositInstructionsPaykuSelectMethod: "选择付款方式",
  depositInstructionsPaykuCreatePayment: "创建付款",
  depositInstructionsPaykuCompletePayment: "完成您的 Payku 付款",
  depositInstructionsPaykuOptions: "在打开的窗口中完成您的付款。",
  depositInstructionsPaykuOpenLink: "打开付款链接",
  depositInstructionsPaykuStatus: "付款状态",
  depositInstructionsPaykuCheckingStatus: "检查状态...",
  depositInstructionsPaykuPending: "待处理",
  depositInstructionsPaykuapproved: "已批准",
  depositInstructionsPaykucompleted: "已完成",
  depositInstructionsPaykurejected: "已拒绝",
  depositInstructionsPaykuexpired: "已过期",
  depositInstructionsPaykuInstructions: "付款处理完成后，您将被重定向回来。",
  depositInstructionsPaykuError: "创建付款失败。请再试一次。",
  depositInstructionsPaykuValidEmail: "请输入有效的电子邮件地址",
  depositInstructionsPaykuPaymentCompleted: "付款成功完成！",
  depositInstructionsPaykuPaymentRejected: "付款被拒绝",
  depositInstructionsPaykuPaymentExpired: "付款已过期",
  depositInstructionsPaykuUnsupportedCurrency: "不支持的货币",
  depositInstructionsPaykuOnlyCLP: "Payku 仅适用于智利比索 (CLP)",
  depositInstructionsPaykuAllMethods: "所有方法",
  depositInstructionsPaykuAllMethodsDescription: "推荐 - 所有可用方法",
  depositInstructionsPaykuWebpayDescription: "最常用的付款方式",
  depositInstructionsPaykuWebpayPlus1_3: "Webpay plus (1-3 期)",
  depositInstructionsPaykuWebpayPlus4_6: "Webpay plus (4-6 期)",
  depositInstructionsPaykuWebpayPlus7_12: "Webpay plus (7-12 期)",
  depositInstructionsPaykuWebpayPlusDesc: "信用选项",

  // PAYKU WITHDRAWAL
  withdrawalPaykuTitle: "Payku CLP 提款",
  withdrawalPaykuAvailableBalance: "可用余额",
  withdrawalPaykuAmount: "金额",
  withdrawalPaykuBeneficiaryName: "受益人姓名",
  withdrawalPaykuEmail: "电子邮件",
  withdrawalPaykuPhone: "电话",
  withdrawalPaykuRUT: "智利 RUT",
  withdrawalPaykuBank: "银行",
  withdrawalPaykuAccountType: "账户类型",
  withdrawalPaykuAccountNumber: "账户号码",
  withdrawalPaykuMinAmount: "最低提款：5,000 CLP",
  withdrawalPaykuSuccessTitle: "提款请求已提交！",
  withdrawalPaykuSuccessMessage: "您的提款请求已成功创建。资金将在接下来的几个小时内处理到您的银行账户。",
  withdrawalPaykuSuccessAmountLabel: "请求金额",
  withdrawalPaykuSuccessBankLabel: "目标银行",
  withdrawalPaykuSuccessClose: "了解",
  withdrawalPaykuEnterAmount: "输入要提取的金额",
  withdrawalPaykuBeneficiaryNamePlaceholder: "账户持有人全名",
  withdrawalPaykuEmailPlaceholder: "你的@邮箱.com",
  withdrawalPaykuPhonePlaceholder: "+56912345678",
  withdrawalPaykuRUTPlaceholder: "12345678-9",
  withdrawalPaykuRUTFormat: "格式：12345678-9",
  withdrawalPaykuSelectBank: "选择银行",
  withdrawalPaykuAccountNumberPlaceholder: "账户号码",
  withdrawalPaykuSubmit: "提交提款",
  withdrawalPaykuSuccess: "提款请求提交成功！",
  withdrawalPaykuError: "提交提款失败。请再试一次。",
  withdrawalPaykuInsufficientBalance: "余额不足",
  withdrawalPaykuBeneficiaryNameRequired: "受益人姓名是必需的",
  withdrawalPaykuValidEmail: "请输入有效的电子邮件地址",
  withdrawalPaykuPhoneRequired: "电话号码是必需的",
  withdrawalPaykuValidRUT: "请输入有效的智利 RUT（格式：12345678-9）",
  withdrawalPaykuBankRequired: "请选择银行",
  withdrawalPaykuAccountNumberRequired: "账户号码是必需的",
  withdrawalPaykuUnsupportedCurrency: "不支持的货币",
  withdrawalPaykuRegisterRUTTitle: "注册你的智利 RUT",
  withdrawalPaykuRegisterRUTDescription:
    "要通过 Payku 提款，我们需要你的 RUT。RUT 只能注册一次，以后所有提款都会使用同一个 RUT。",
  withdrawalPaykuRegisterRUTSubmit: "注册 RUT",
  withdrawalPaykuRegisterRUTWarning: "重要：一旦注册，此 RUT 无法修改，并且你只能提款到与此 RUT 关联的银行账户。",
  withdrawalPaykuRUTRegistrationWarning: "你只能注册 RUT 一次，请确认输入正确。",
  withdrawalPaykuRUTRegistrationError: "无法注册 RUT，请重试。",
  withdrawalPaykuRUTLockedHint: "仅允许提款到与此 RUT 关联的银行账户。",
  withdrawalPaykuCreateAccountTitle: "添加智利银行账户",
  withdrawalPaykuCreateAccountSubmit: "保存账户",
  withdrawalPaykuBankAccountRequiredFields: "银行、账号和持有人姓名是必填项。",
  withdrawalPaykuBankAccountCreateError: "无法创建银行账户，请重试。",
  withdrawalPaykuSelectAccount: "选择银行账户",
  withdrawalPaykuSelectAccountRequired: "请选择一个银行账户。",
  withdrawalPaykuAddNewAccount: "添加新账户",
  withdrawalPaykuDeleteAccount: "删除账户",
  withdrawalPaykuOnlyCLP: "Payku 提款仅适用于智利比索 (CLP)",

  // PAYKU CALLBACK PAGE
  paykuCallbackVerifying: "验证付款",
  paykuCallbackVerifyingMessage: "请稍候，我们正在验证您的交易状态...",
  paykuCallbackSuccess: "付款成功！",
  paykuCallbackSuccessMessage: "您的存款已成功处理。余额已存入您的账户。",
  paykuCallbackFailed: "付款失败",
  paykuCallbackFailedMessage: "抱歉，您的付款无法处理。请重试或联系客服。",
  paykuCallbackPending: "付款待处理",
  paykuCallbackPendingMessage: "您的付款正在处理中。完成后您将收到通知。",
  paykuCallbackOrderId: "订单编号",
  paykuCallbackAmount: "金额",
  paykuCallbackRedirectMessage: "您将在 {{seconds}} 秒后被重定向到主页...",
  paykuCallbackGoHome: "返回首页",
};
